import Accordian from "./accordian/Accordian";
const App = () => {
  return (
    <>
      <Accordian />
    </>
  );
};

export default App;
